import { render } from "./AddPhaseNoteModal.vue?vue&type=template&id=07ff7fc0&scoped=true&ts=true"
import script from "./AddPhaseNoteModal.vue?vue&type=script&lang=ts"
export * from "./AddPhaseNoteModal.vue?vue&type=script&lang=ts"

import "./AddPhaseNoteModal.vue?vue&type=style&index=0&id=07ff7fc0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ff7fc0"]])

export default __exports__